import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const checkEncore = createApiAction(
  types.HEALTH_CHECK_ENCORE,
  () => api.checkEncore(),
);

export const checkResto = createApiAction(
  types.HEALTH_CHECK_RESTO,
  () => api.checkResto(),
);

export const checkUserService = createApiAction(
  types.HEALTH_CHECK_USERSERVICE,
  () => api.checkUserService(),
);

export const cleanup = createAction(types.CLEANUP);
